import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig, ActiveState } from '@datorama/akita';
import { Organization } from '../shared/types';

export interface OrganizationsState extends EntityState<Organization, string>, ActiveState<string> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'organizations' })
export class OrganizationsStore extends EntityStore<OrganizationsState> {

  constructor() {
    super();
  }

}
